/* src/app/shared/components/search/search.component.scss */
.search-container,
.close-icon {
  position: relative;
}
.search-container .clear-input,
.close-icon .clear-input {
  position: absolute;
  top: 6px;
  right: 6px;
  cursor: pointer;
  width: 24px;
  height: 24px;
  background: none;
  border: none;
  padding: 2px 0 0;
}
.close-icon {
  border: 1px solid transparent;
  background-color: transparent;
  display: inline-block;
  vertical-align: middle;
  outline: 0;
  top: 16px;
  right: -35px;
  cursor: pointer;
}
.clear-input:focus {
  outline: 1px solid #007c91;
  box-shadow: 0 0 0 2px rgba(0, 124, 145, 0.8);
}
.close-icon:after {
  content: "X";
  display: block;
  width: 15px;
  height: 15px;
  position: absolute;
  background-color: #fa9595;
  z-index: 1;
  right: 43px;
  top: 0;
  bottom: 0;
  margin: auto;
  padding: 0px;
  border-radius: 50%;
  text-align: center;
  color: white;
  font-weight: normal;
  font-size: 12px;
  box-shadow: 0 0 2px #e50f0f;
  cursor: pointer;
}
/*# sourceMappingURL=search.component.css.map */
